import { cn } from "@/lib/utils";

/** First letter of a username, for avatars. */
export function initialOf(name: string): string {
  return (name.trim().charAt(0) || "?").toUpperCase();
}

/**
 * A person's initial in a circle. "self" is neutral; "friend" is the
 * friend-mode violet, fixed so friends read as friends in any context;
 * "current" follows the page's primary colour (violet in friend mode).
 */
export function PersonAvatar({
  name,
  tone,
  className,
}: {
  name: string;
  tone: "self" | "friend" | "current";
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex size-8 shrink-0 select-none items-center justify-center rounded-full text-sm font-semibold",
        tone === "self" && "bg-muted text-foreground ring-1 ring-inset ring-border",
        tone === "friend" && "bg-violet-100 text-violet-800 dark:bg-violet-900/60 dark:text-violet-100",
        tone === "current" && "bg-primary text-primary-foreground",
        className,
      )}
    >
      {initialOf(name)}
    </span>
  );
}
